import { Pipe } from '@angular/core';
import { isString, extractDeepPropertyByMapKey, isNumberFinite, isBoolean, isUndefined } from '../helpers/helpers';
var FilterByPipe = (function () {
    function FilterByPipe() {
    }
    FilterByPipe.prototype.transform = function (input, props, search, strict) {
        if (search === void 0) { search = ''; }
        if (strict === void 0) { strict = false; }
        if (!Array.isArray(input) || (!isString(search) && !isNumberFinite(search) && !isBoolean(search))) {
            return input;
        }
        var term = String(search).toLowerCase();
        return input.filter(function (obj) {
            return props.some(function (prop) {
                var value = extractDeepPropertyByMapKey(obj, prop), strValue = String(value).toLowerCase();
                if (isUndefined(value)) {
                    return false;
                }
                return strict
                    ? term === strValue
                    : !!~strValue.indexOf(term);
            });
        });
    };
    return FilterByPipe;
}());
export { FilterByPipe };
FilterByPipe.decorators = [
    { type: Pipe, args: [{ name: 'filterBy' },] },
];
/** @nocollapse */
FilterByPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=filter-by.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/array/filter-by.js
// module id = 123
// module chunks = 4